














import { Component, Vue } from 'vue-property-decorator';
import { redirectToLocation } from '@/commons/redirectManager';
import CmsBlock from '@/components/Cms/Block.vue';
import ui from '@/store/modules/ui';

@Component({
  components: {
    CmsBlock,
  },
})
export default class CartFooter extends Vue {

  get backButtonLabel(): string  {
    if (this.$router.currentRoute.name === 'cart') {
      return 'Back to store';
    } else {
      return 'Back to cart';
    }
  }

  private redirectToHome() {
    if (this.$router.currentRoute.name === 'cart') {
      redirectToLocation('/');
    } else {
      this.$router.push({ path: '/' });
      ui.popSidebar();
    }
  }
}
